<template>
  <div id="mProject" :class="pageClass">
    <Nav type="transparent" />
    <span class="pageTitle" v-html="pageTitle"></span>
    <div style="height: 1px;"></div>
    <div class="tabBar">
      <router-link to="/Project/1" :class="{ active: $route.params.type == 1 }"
        >皮肤管理</router-link
      >
      <router-link to="/Project/2" :class="{ active: $route.params.type == 2 }"
        >头皮管理</router-link
      >
      <router-link to="/Project/3" :class="{ active: $route.params.type == 3 }"
        >身体智能管理</router-link
      >
      <!-- <router-link to="/Project/4" :class="{ active: $route.params.type == 4 }">持久妆</router-link> -->
    </div>
    <div class="tabContent">
      <!-- <router-link
        :to="`/ProjectDetail/${$route.params.type}/${item.id}`"
        v-for="(item, index) in list"
        :key="index"
        :class="{ hasThumb: item.thumbHover }"
      >
        <img :src="`img/${item.thumb}`" alt />
        <i v-if="item.thumbHover" :style="{ 'background-image': `url(img/${item.thumbHover})` }"></i>
        <p class="proTit" v-html="item.name"></p>
        <p class="proText" v-html="item.title"></p>
      </router-link>-->
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="itemClick(index, item)"
        :class="{ hover: itemActive == index }"
      >
        <div class="imgBox" :class="{ hasThumb: item.thumbHover }">
          <img :src="require(`@/assets/${item.thumb}`)" alt />
          <i
            v-if="item.thumbHover"
            :style="{ 'background-image': `url(${require(`@/assets/${item.thumbHover}`)})` }"
          ></i>
          <!-- <span>快速浏览</span> -->
        </div>
        <p class="proTit" v-html="item.name"></p>
        <p class="proText" v-html="item.title"></p>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import data from "@/utils/projectData.js";
export default {
  name: "mProject",
  data() {
    return {
      active: 1,
      list: [],
      pageClass: "",
      pageTitle: "",
      isIpad: true,
      itemActive: -1,
    };
  },
  components: {
    Nav,
  },
  computed: {},
  watch: {
    "$route.params.type"(t) {
      this.getData();
    },
  },
  methods: {
    getData() {
      switch (this.$route.params.type) {
        case "1":
          this.list = data.skin.data;
          this.pageClass = data.skin.pageClass;
          this.pageTitle = data.skin.pageTitle;
          break;
        case "2":
          this.list = data.head.data;
          this.pageClass = data.head.pageClass;
          this.pageTitle = data.head.pageTitle;
          break;
        case "3":
          this.list = data.body.data;
          this.pageClass = data.body.pageClass;
          this.pageTitle = data.body.pageTitle;
          break;
        case "4":
          this.list = data.face.data;
          this.pageClass = data.face.pageClass;
          this.pageTitle = data.face.pageTitle;
          break;
        default:
          this.list = data.skin.data;
          this.pageClass = data.skin.pageClass;
          this.pageTitle = data.skin.pageTitle;
      }
    },
    itemClick(i, item) {
      // if (!this.isIpad) return;
      // this.itemActive = i;
      if (this.isIpad && this.itemActive != i) {
        this.itemActive = i;
        return;
      }
      this.goToDetial(`/ProjectDetail/${this.$route.params.type}/${item.id}`);
    },
    pcHover(i) {
      if (this.isIpad) return;
      this.itemActive = i;
    },
    pcHoverOut() {
      this.itemActive = -1;
    },
    goToDetial(path) {
      this.$router.push(path);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
#mProject {
  padding: 350px 32px 140px;
  background: url(../assets/project-banner.jpg) top/100% no-repeat;
  &.project1 {
    background-image: url(../assets/project-banner.jpg);
  }
  &.project2 {
    background-image: url(../assets/project-banner2.jpg);
  }
  &.project3 {
    background-image: url(../assets/project-banner3.jpg);
  }
  &.project4 {
    background-image: url(../assets/project-banner4.jpg);
  }
}
.tabBar {
  margin: 8px 0;
  text-align: center;
  border-bottom: 1px solid #f2f2f2;
  > a {
    position: relative;
    display: inline-block;
    margin: 0 25px;
    font-size: 26px;
    line-height: 90px;
    color: #a4a4a4;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -2px;
      width: 100%;
      border-bottom: 1px solid #000;
      opacity: 0;
      transition: all 0.5s;
      transform: scale(0.4);
    }
    &.active {
      font-weight: 500;
      color: #313131;
    }
    &.active::after {
      opacity: 1;
      transform: scale(1.2);
    }
  }
}
// .tabContent {
//   margin: 0 auto;
//   width: 540px;

//   > a {
//     position: relative;
//     display: block;
//     margin-top: 100px;
//     border: 1px solid transparent;

//     &::after {
//       content: "快速浏览";
//       position: absolute;
//       left: 0;
//       top: 568px;
//       width: 100%;
//       height: 80px;
//       font-weight: 400;
//       font-size: 28px;
//       line-height: 80px;
//       color: #313131;
//       text-align: center;
//       background: rgba(255, 255, 255, 0.6);
//       opacity: 0;
//       transition: all 0.5s;
//     }
//     &:hover,
//     &:focus,
//     &:active {
//       color: #313131;
//       fill: #313131;
//     }
//     // &:hover.hasThumb::after,
//     // &:hover.hasThumb i {
//     //   opacity: 1;
//     // }

//     i {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 100%;
//       height: 648px;
//       background: left/100% 100% no-repeat;
//       opacity: 0;
//       transition: all 0.5s;
//     }

//     > img {
//       display: block;
//       width: 100%;
//     }
//   }
// }
.tabContent {
  margin: 0 auto;
  width: 540px;

  > div {
    display: block;
    position: relative;
    margin-top: 100px;
    border: 1px solid transparent;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -20px;
      width: 100%;
      border-bottom: 1px solid #000;
      opacity: 0;
      // transition: all 0.5s;
      // transform: scale(0.4);
    }
    &.hover {
      color: #313131;
      fill: #313131;

      > a {
        display: block;
      }

      .imgBox.hasThumb {
        span,
        i {
          opacity: 1;
        }
      }
    }
    // &.hover::after {
    //   opacity: 1;
    //   transform: scale(1);
    // }

    > a {
      display: none;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    .imgBox {
      position: relative;
      img {
        display: block;
        width: 100%;
      }
      i {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: left/100% 100% no-repeat;
        opacity: 0;
        transition: all 0.5s;
      }
      span {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 80px;
        font-weight: 400;
        font-size: 28px;
        line-height: 80px;
        color: #313131;
        text-align: center;
        background: rgba(255, 255, 255, 0.6);
        opacity: 0;
        transition: all 0.5s;
        &:hover {
          font-weight: 400;
        }
      }
    }
  }
}
.proTit {
  margin-top: 32px;
  font-size: 24px;
  line-height: 32px;
  color: #313131;
}
.proText {
  margin-top: 8px;
  font-weight: 400;
  font-size: 28px;
  line-height: 38px;
  color: #313131;
}
</style>
